import { render, staticRenderFns } from "./PreviewP1.vue?vue&type=template&id=3ab8a466"
import script from "./PreviewP1.vue?vue&type=script&lang=ts"
export * from "./PreviewP1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports